<template>
  <div class="search header-item">
    <img src="../assets/search.svg" alt="Search">
    <form @submit.prevent="search">
      <b-input v-model="searchQuery"
               class="user-search"
               type="text"
               icon="magnify"
               :placeholder="$t('interface.globalSearchPlaceholder')">
      </b-input>
    </form>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import {debounce} from '@/utils'
  import defaultUserThumb from '../assets/user.svg'

  export default {
    data() {
      return {
        searchQuery: null
      }
    },
    methods: {
      search() {
        this.$router.replace({name: 'globalSearch', query: {q: this.searchQuery}})
      }
    },
    computed: {
      ...mapState('Employees', ['loading', 'searchResults']),
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/variables";

  form {
    display: inline-block;
  }

  .search {
    input {
      margin: 0;
      border: 0;
      height: $header-height;
      padding: 0 16px;
      color: #757575;
      font-size: 15px;
      width: 340px;

      &::placeholder {
        color: #C3C3C3;
        opacity: 1;
      }

      &:-ms-input-placeholder {
        color: #C3C3C3;
      }

      &::-ms-input-placeholder {
        color: #C3C3C3;
      }
    }

    img {
      vertical-align: sub;
    }
  }
</style>